import { BasePlaylistRotationControllerEvents } from '@streamLoader/BasePlaylistRotationController/BasePlaylistRotationController.events';
import { FragmentLoaderEvents } from '@streamLoader/FragmentLoader/FragmentLoader.events';

// eslint-disable-next-line @typescript-eslint/typedef
export const StreamLoaderModuleEvents = {
  fragmentLoader: FragmentLoaderEvents,
  playlistRotator: BasePlaylistRotationControllerEvents,
  streamLoader: {
    playlistRotatorTypeChanged: 'streamLoader.playlistRotatorTypeChanged',
  },
};
